import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import type { Location } from 'react-router-dom'
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom'

import { clearShortlist } from '@disco/state-management/actions/shortlist-upload-actions'

import { getShortlistBaseRoute } from 'utils/routing'

import DocumentHeadTags from 'components/document-head-tags'
import ModalDialog from 'components/ui/modal-dialog'

interface OwnProps {
  params: {
    shortlistId: string
  }
  navigate: NavigateFunction
  location: Location
}

const mapDispatchToProps = {
  clearShortlist,
}

const connector = connect(null, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type Props = PropsFromRedux & OwnProps

class ShortlistsClear extends React.Component<Props> {
  _onClose = () => {
    const baseRoute = getShortlistBaseRoute(this.props.location)
    const returnPath = baseRoute || '/'
    this.props.navigate(returnPath)
  }
  _handleItemsDelete = () => {
    this.props.clearShortlist(this.props.params.shortlistId)

    this._onClose()
  }

  render() {
    return (
      <div>
        <DocumentHeadTags title="Clear playlist | DISCO" />
        <ModalDialog
          title="Clear playlist"
          primaryAction={{
            caption: 'Clear',
            onClick: this._handleItemsDelete,
          }}
          status="danger"
          onCancel={this._onClose}
        >
          Are you sure you want to clear this playlist? This can’t be undone.
        </ModalDialog>
      </div>
    )
  }
}

const ConnectedShortlistsClear = connector(ShortlistsClear)

function ShortlistsClearWithNavigate(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ shortlistId: string }>()
  const location = useLocation()
  return (
    <ConnectedShortlistsClear
      {...props}
      navigate={navigate}
      params={params}
      location={location}
    />
  )
}

export default ShortlistsClearWithNavigate as any
